module.exports = __webpack_public_path__ + "static/media/  (98).23c007a6.jpg";